export const label = 'font-medium block text-base font-body text-textMid';
export const hintStyle = 'block mt-1 text-sm font-body text-textMid';
